import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ShieldCheck } from 'lucide-react';
export function RevelationSection() {
  return <section className="py-20 px-4 bg-brand-muted relative overflow-hidden" data-id="element-133">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-134">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl" data-id="element-135"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-teal/5 rounded-full blur-3xl" data-id="element-136"></div>
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-brand-navy/5" data-id="element-138">
          <div className="flex justify-center mb-8" data-id="element-139">
            <span className="bg-brand-teal/10 text-brand-teal px-4 py-2 rounded-full text-sm font-bold tracking-wider uppercase flex items-center gap-2" data-id="element-140">
              <Sparkles className="w-4 h-4" data-id="element-141" />
              La Verdad Oculta
            </span>
          </div>

          <p className="text-lg md:text-xl text-brand-navy leading-relaxed mb-8" data-id="element-142">
            La verdad que los gurús de la "crianza respetuosa" no te dicen es
            que{' '}
            <strong className="text-brand-coral" data-id="element-143">
              la disciplina tradicional no funciona con un cerebro saturado de
              dopamina artificial
            </strong>
            . No puedes razonar con un niño que tiene el sistema nervioso
            alterado por luces de colores y sonidos estridentes de TikTok o
            Roblox.
          </p>

          <div className="bg-brand-cream p-6 rounded-2xl border-l-4 border-brand-teal" data-id="element-144">
            <p className="text-lg md:text-xl text-brand-navy leading-relaxed font-serif" data-id="element-145">
              Para recuperar a tu hijo, no necesitas más paciencia. Necesitas un{' '}
              <strong className="text-brand-teal font-bold" data-id="element-146">
                Protocolo de Reseteo Dopaminérgico
              </strong>
              . Necesitas limpiar sus receptores químicos para que el mundo real
              vuelva a ser interesante para él. Y lo mejor: puedes hacerlo sin
              ser una experta en psicología.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}